import { render, staticRenderFns } from "./QuestionType10.vue?vue&type=template&id=0424dd5e&scoped=true"
import script from "./QuestionType10.vue?vue&type=script&lang=js"
export * from "./QuestionType10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424dd5e",
  null
  
)

export default component.exports